import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { FiberManualRecord as CircleIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';

dayjs.extend(relativeTime);

type LastConnectedProps = {
    timestamp: string | null | undefined;
};

// ? The number of milliseconds after which the dot should be red
const THRESHOLD = 60_000 * 60;

export const LastConnected = ({ timestamp }: LastConnectedProps) => {
    const difference = timestamp ? Date.now() - new Date(timestamp).getTime() : null;
    const text = difference ? dayjs().to(timestamp) : 'Unknown';

    return (
        <Typography display='flex' alignItems='center'>
            <CircleIcon
                fontSize='small'
                sx={{
                    color: difference ? (difference >= THRESHOLD ? 'red' : 'green') : 'grey',
                }}
            />

            {text}
        </Typography>
    );
};
